

/**
 * 通用js方法封装处理
 */

// 金额转换（分——元），保留2位小数
export function formatMoney(money = 0, base = 100) {
  return Math.round((+money / base) * 100) / 100;
}

// 浮点数运算
export function formatStrip(num, precision = 12) {
  return +parseFloat(num.toPrecision(precision));
}

// 公里转换（里——公里），保留2位小数
export function formatMile(mile = 0) {
  return Math.round((mile / 1000) * 100) / 100;
}

// 日期格式化
export function formatTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  // '{y}-{m}-{d} {h}:{i}:{s}'
  const format = pattern || '{y}-{m}-{d} {h}:{i}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}
